import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ApiError, RecordingViewParams, RecordingViewResponse } from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<RecordingViewResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchRecording = async ({
    id,
}: RecordingViewParams): Promise<RecordingViewResponse> => {
    if (id == null) throw new Error('Interaction ID is required');
    const url = apiEndpoints.recordings.getSingle(id);
    const response = await api.get(url, {
        responseType: 'blob',
    });
    const blob = response?.data;
    const match = response.headers['content-disposition'].match(/filename\s*=\s*"(.+)"/i);
    const filename = match?.[1] || 'brands.csv';
    return { blob, filename };
};

const useRecording = (params: RecordingViewParams, options?: QueryOptions) => {
    return useQuery<RecordingViewResponse, ApiError>({
        queryKey: ['recording', 'single', params],
        queryFn: () => fetchRecording(params),
        enabled: Boolean(params.id),
        ...options,
    });
};

export default useRecording;
